import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { cloneDeep } from "lodash";
import playSound from "@/sound";
import {
  correctSound,
  incorrectSound,
  blockTouch,
  sleep,
  shuffle,
  getWord,
} from "@stores/vars";
import { atom, useAtom } from "jotai";
import TimeBar from "@components/TimeBar";
import anime from "animejs/lib/anime.es.js";
import GameScore from "@components/traingame/GameScore";
import GameCompletePop from "@components/elements/GameCompletePop";
import { useCallback } from "react";
import DropItem from "@components/traingame/DropItem";
import DragItem from "@components/traingame/DragItem";

const Wrap = styled.div`
  position: relative;
  height: 1200px;
  background: url(${require("@assets/img/traingame/bg.jpg")}) no-repeat;
  z-index: 0;
`;
const TimeBarWrap = styled.div`
  position: absolute;
  left: 200px;
  top: 30px;
`;

const GameContainer = styled.div`
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const TrainWrap = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  left: 0;
  top: 180px;
  height: 770px;
  opacity: 0;

  .t-head {
    &:before {
      content: "";
      position: absolute;
      width: 1250px;
      height: 30px;
      top: 622px;
      left: 510px;
      background-color: #21190f;
      z-index: -1;
    }
  }

  &.item-2 {
    width: 1890px;
    .t-head {
      &:before {
        width: 950px;
      }
    }
  }

  &.item-3 {
    width: 2280px;
    .t-head {
      &:before {
        width: 1250px;
      }
    }
  }
`;

const TrainHead = styled.div`
  width: 541px;
  height: 546px;
  background: url(${require("@assets/img/traingame/t-start.png")}) no-repeat;
`;

const TrainBox = styled.div`
  position: relative;
  width: 570px;
  height: 398px;
  background: url(${require("@assets/img/traingame/t-holder.png")}) no-repeat;

  .t-word {
    transition: opacity 0.3s;
    opacity: 0;
  }
  .t-card {
    transform: translateY(0);
    opacity: 1;
    align-items: center;
    justify-content: center;
  }

  &.active {
    background: url(${require("@assets/img/traingame/t-holder_active.png")})
      no-repeat;

    .t-word {
      opacity: 1;
    }
    .t-card {
      transition: all 0.5s cubic-bezier(0.36, 0, 0.66, -0.56);
      transform: translateY(320px);
      opacity: 0;
    }
  }
`;

const TrainCard = styled.div`
  position: relative;
  width: 465px;
  height: 365px;
  left: 50px;
  top: -345px;
  z-index: -1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  background: url(${require("@assets/img/traingame/t-card.png")}) no-repeat;
`;
const TInner = styled.div`
  position: absolute;
  overflow: hidden;
  width: calc(100% - 30px);
  border-radius: 30px;
  left: 15px;
  top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    //margin-top: 20px;
    width: auto;
    height: 335px;
  }
`;
const WordWrap = styled.div`
  position: absolute;
  left: 0;
  bottom: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const Word = styled.div`
  position: absolute;
  left: 31px;
  top: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 120px;
  color: #2b2b2b;
  font-size: 45px;
  text-align: center;
  line-height: 1;
  //font-family: "Noto Sans SC";
`;

const BtnGo = styled.button`
  display: block;
  width: 436px;
  height: 142px;
  position: absolute;
  left: 50%;
  margin-left: -218px;
  top: 270px;
  background: url(${require("@assets/img/traingame/go_btn.png")});
  display: none;
  opacity: 0;
`;
let isTrainGameTimeOver = false;
const score_ = atom(0);
const GameTrain = ({ data, endClick }) => {
  const categoryKey = data.categoryKey;
  const colors = ["#16c8b1", "#ffb400", "#ff8400"];
  const [isComplete, setComplete] = useState(false);
  const [clearCount, setClearCount] = useState(0);
  const [tData, setData] = useState({
    sources: [],
    holders: [],
  });
  const [isStart, setStart] = useState(false);
  const [score, setScore] = useAtom(score_);

  const timeOver = useCallback(() => {
    isTrainGameTimeOver = true;
    playSound.wordStop();
    blockTouch();

    (async () => {
      await sleep(1000);
      setClearCount(0);
      setComplete(true);
    })();
  }, []);

  const onSuccess = async (_data) => {
    blockTouch();
    playSound.effect(correctSound);
    const sData = [...tData.sources];
    const hData = [...tData.holders];
    setScore(score + 1);
    setData({
      sources: sData.map((d) => {
        return {
          ...d,
          isClear: d.isClear === true ? true : d.word === _data.word,
        };
      }),
      holders: hData.map((d) => {
        return {
          ...d,
          isClear: d.isClear === true ? true : d.word === _data.word,
        };
      }),
    });
    await sleep(1000);
    if (isTrainGameTimeOver) return;
    await playSound.word(_data.sound);
    blockTouch(false);
    if (clearCount + 1 === tData.sources.length) {
      blockTouch();
      (async () => {
        setClearCount(0);
        await sleep(200);
        if (isTrainGameTimeOver) return;
        const out = document.querySelector(".goOut");
        playSound.word(
          require("@data/assets/_static/sounds/traingame_end.mp3")
        );
        out.style.display = "block";
        anime({
          targets: ".goOut",
          translateY: [-100, 0],
          opacity: [0, 1],
          easing: "easeOutBack",
          duration: 600,
          complete: () => {
            blockTouch(false);
          },
        });
      })();
    } else {
      setClearCount(clearCount + 1);
    }
  };

  const onRevert = () => {
    playSound.effect(incorrectSound);
  };

  const outTrain = () => {
    blockTouch();
    const out = document.querySelector(".goOut");
    playSound.effect(require("@assets/sounds/effects/train_out.mp3"));
    out.style.display = "none";
    const outX = tData.sources.length === 2 ? -1900 : -2290;
    const startX = tData.sources.length === 2 ? -310 : -445;
    anime({
      targets: ".train-wrap",
      translateX: [startX, outX],
      easing: "easeInCubic",
      duration: 700,
      complete: () => {
        resetGame();
      },
    });
  };

  const resetGame = async () => {
    isTrainGameTimeOver = false;
    blockTouch();
    const out = document.querySelector(".goOut");
    out.style.display = "none";

    const _data = cloneDeep(shuffle(data.data.resources)).splice(0, 3);
    await setData({
      sources: shuffle(_data),
      holders: shuffle(_data),
    });
    anime({
      targets: ".train-wrap",
      opacity: [1, 1],
      translateX: [1950, tData.sources.length === 2 ? -310 : -445],
      easing: "easeOutCubic",
      duration: 1500,
      complete: () => {
        blockTouch(false);
      },
    });
  };

  // game start, end
  useEffect(() => {
    if (isStart) {
      (async () => {
        setScore(0);
        resetGame();
      })();
    } else {
      anime({
        targets: ".train-wrap",
        opacity: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStart]);

  useEffect(() => {
    playSound.bgm(require("@assets/sounds/bgm/train.mp3"));
    setStart(true);
    return () => {
      isTrainGameTimeOver = false;
      setScore(0);
      playSound.wordStop();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap>
      <TimeBarWrap>
        <TimeBar
          isStart={isStart}
          total={60}
          onSuccess={timeOver}
          cName="train"
        />
      </TimeBarWrap>
      <GameScore score={score} />

      <GameContainer>
        <TrainWrap className={`train-wrap item-${tData.sources.length}`}>
          <TrainHead className="t-head" />
          {tData.holders.map((data, i) => {
            return (
              <TrainBox key={i} className={data.isClear ? "active" : ""}>
                <TrainCard className="t-card">
                  <TInner>
                    <img src={data.img} alt="" />
                  </TInner>
                </TrainCard>
                <Word className="t-word cha">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getWord(data.word, categoryKey),
                    }}
                  />
                </Word>
                <DropItem
                  isClear={false}
                  data={data}
                  categoryKey={categoryKey}
                />
              </TrainBox>
            );
          })}
        </TrainWrap>
        <BtnGo type="button" onClick={outTrain} className="goOut" />
        <WordWrap>
          {tData.sources.map((data, i) => {
            return (
              <DragItem
                cName="drag-item"
                key={i}
                data={data}
                categoryKey={categoryKey}
                color={colors[i]}
                onSuccess={onSuccess}
                onRevert={onRevert}
                isClear={data.isClear}
              />
            );
          })}
        </WordWrap>
      </GameContainer>
      {isComplete && (
        <GameCompletePop
          score={score}
          onRestartClick={() => {
            setComplete(false);
            setStart(false);
            sleep(1000).then(() => {
              setStart(true);
            });
          }}
          onEndClick={endClick}
        />
      )}
    </Wrap>
  );
};
export default GameTrain;
